import { Box, Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import CTable from "../../../components/Table/table";
import { getAllGroupsRequest } from "../../../modules/admin-modules/groups/Actions";
import { unpaidReportRequest } from "../../../modules/superadmin-modules/reports/Actions";
import { getPaymentSubjectRequest } from "../../../modules/superadmin-modules/videos/Actions";

const UnpaiedReport = ({ setAdd, setSelectedData, searchTerm }) => {
  const dispatch = useDispatch();
  const [groupId, setGroupId] = useState("");
  const [paymentSubjectId, setPaymentSubjectId] = useState("");
  useEffect(() => {
    if (groupId) dispatch(unpaidReportRequest(groupId, paymentSubjectId));
  }, [groupId, paymentSubjectId]);

  useEffect(() => {
    dispatch(getAllGroupsRequest());
    dispatch(getPaymentSubjectRequest());
  }, []);
  const groups = useSelector((state) => state.groups.groups);
  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const unpaidReport = useSelector((state) => state.reports.unpaidReport);
  const iaLoading = useSelector((state) => state.reports.iaLoading);
  const paymentSubjects = useSelector((state) => state.videos.paymentSubjects);
  const paymentSubjectsOptions = paymentSubjects?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const [offset, setPage] = useState(0);

  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };
  const headers = [
    { label: "name", key: "name" },
    { label: "group_name", key: "group_name" },
    { label: "phone", key: "phone" },
    { label: "parent_phone", key: "parent_pone" },
  ];
  const Data = unpaidReport?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      name: data?.name,
      group_name: data?.group?.name,
      phone: data?.phone,
    };
  });
  const columns = [
    {
      Header: "رقم الطالب",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "name",
    },
    {
      Header: " المجموعة",
      accessor: "group_name",
    },

    {
      Header: " رقم  الطالب",
      accessor: "phone",
    },
  ];

  return (
    <Layout>
      <div style={{ minHeight: "400px" }}>
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          zIndex="10000000"
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            تقرير عدم الدفع
          </Text>
          <Flex w="60%" justifyContent="space-between" alignItems="center">
            <Box w="70%">
              <Select
                options={groupsOptions}
                isMulti={false}
                onChange={(data) => {
                  setGroupId(data?.value);
                }}
                styles={colourStyles}
                placeholder="Select Group"
              />
            </Box>
            <Box w="70%">
              <Select
                options={paymentSubjectsOptions}
                isMulti={false}
                onChange={(data) => {
                  setPaymentSubjectId(data?.value);
                }}
                styles={colourStyles}
                placeholder="Select Payment Subject"
              />
            </Box>
            <Box
              mx="10px"
              border="1px solid gray"
              borderRadius="8px"
              padding="10px"
            >
              <CSVLink
                headers={headers}
                data={Data?.length != 0 ? Data : [{}]}
                filename={"unpaid-report.csv"}
                className="btn btn-primary"
                target="_blank"
              >
                Download
              </CSVLink>
            </Box>
            <LogoutMenu />
          </Flex>
        </Flex>

        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data}
          path={"openModel"}
          Actions
          Title={``}
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar={true}
          noFilter={true}
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar={true}
          isLoading={iaLoading}
          perPage={size}
          totalPage={Math.ceil(10 / 50)}
        />
      </div>
    </Layout>
  );
};

export default UnpaiedReport;
